import { legacyColors } from '~/legacyTheme';
import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    listItemRoot: {
      position: 'relative',
      cursor: 'pointer',
      textTransform: 'initial',
      '& .listItemTextMultiline': {
        borderBottom: `1px solid ${legacyColors.grey5}`,
      },
      '&:hover .listItemTextMultiline': {
        borderBottomColor: legacyColors.blue,
      },
      '&:hover .avatar': {
        msTransform: 'scale(1.2)',
        webkitTransform: 'scale(1.2)',
        transform: 'scale(1.2)',
        border: `2px solid ${legacyColors.blue}`,
      },
    },
    primaryElement: { fontWeight: 'bold' },
    secondaryElement: {
      color: theme.palette.text.primary,
    },
    statusNew: {
      backgroundColor: legacyColors.text.success,
      color: theme.palette.common.white,
      fontSize: '12px',
      padding: '2px 4px',
      border: `1px solid ${legacyColors.grey5}`,
      borderRadius: '3px',
      position: 'absolute',
      top: '4px',
      right: '4px',
    },
  };
};
